import {Component, ElementRef, Input, OnInit, ViewChild, ViewChildren, ViewEncapsulation} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {NormalizadorService} from '../../services/normalizador.service';
import {ResultadoService} from '../../services/resultado.service';
import {GeneralService} from '../../services/general.service';
import {getNameStreet, onChangeZip, searchRoadType} from 'src/app/utils/normalizerFunctions';
import {ApiAmenaService} from '../../services/api-amena.service';

@Component({
    selector: 'app-normaliza-direccion',
    templateUrl: './normaliza-direccion.component.html',
    styleUrls: ['./normaliza-direccion.component.css', '../../../../assets/css/amena-theme.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class NormalizaDireccionComponent implements OnInit {
    // Importamos el formGroup del amena componente
    @Input() firstFormGroup: FormGroup;
    @ViewChild('manualAddress') manualAddress;
    @ViewChild('manualAddressText') manualAddressText;
    @ViewChild('formNumber') formNumber: ElementRef;

    // Variable que afecta a la vista del formulario
    country = 'es';
    muestraNormalizacion = false;
    // Variable que afecta a la vista del botón
    muestraBoton = true;
    muestraErrorPeticion = false;
    isLoading = false;
    textDefault = 'Normaliza dirección';
    // Datos para el modelo
    datosTipoVia: any[] = [];
    datosProvincia: any[] = [];
    msgErrorPeticion: any;
    datosEdicion: any;
    public migrationData: any;

    constructor(
        private formBuilder: FormBuilder,
        protected normalizadorService: NormalizadorService,
        private resultadoService: ResultadoService,
        private generalService: GeneralService,
        private amenaService: ApiAmenaService
    ) {
    }

    ngOnInit(): void {
        // Definimos el formGroup y los formControl que llevara el formulario
        this.firstFormGroup = this.formBuilder.group({
            tipoViaNormaliza: [''],
            nombreViaNormaliza: ['', Validators.required],
            numeroNormaliza: ['', Validators.required],
            codigoPostalNormaliza: ['', Validators.required],
            localidadNormaliza: ['', Validators.required],
            provinciaNormaliza: ['', Validators.required]
        });

        // Obtenemos los datos para tipo vía y provincia
        this.amenaService.getDatosTipoVia()
            .subscribe((data: any) => {
                if (data != null) {
                    this.datosTipoVia = data;
                }
            });

        this.amenaService.getProvincias()
            .subscribe((data) => {
                if (data) {
                    this.datosProvincia = data;
                }
            });

        this.firstFormGroup.enable();
        // Afecta a la visibilidad del formulario
        this.normalizadorService.getMuestraNormalizacion()
            .subscribe((value) => {
                this.muestraNormalizacion = value;
            });

        // Afecta a la visibilidad del botón de envío
        this.normalizadorService.getMuestraBotonNormalizacion()
            .subscribe((value) => {
                this.muestraBoton = value;
            });

        // Errores petición http o direcciones vacias
        this.normalizadorService.getErrorPeticionNormaliza()
            .subscribe((value) => {
                this.muestraErrorPeticion = value;
            });

        this.normalizadorService.getMsgErrorNormaliza()
            .subscribe((value) => {
                this.msgErrorPeticion = value;
            });

        // Datos enviados en el formulario en primera instancia
        this.resultadoService.getDataEdicion()
            .subscribe((value) => {
                if (value) {
                    this.datosEdicion = value;
                    this.firstFormGroup.get('codigoPostalNormaliza').patchValue(this.datosEdicion.codigoPostalNormaliza);
                    this.firstFormGroup.get('localidadNormaliza').patchValue(this.datosEdicion.localidadNormaliza);
                    this.firstFormGroup.get('nombreViaNormaliza').patchValue(this.datosEdicion.nombreViaNormaliza);
                    this.firstFormGroup.get('numeroNormaliza').patchValue(this.datosEdicion.numeroNormaliza);
                    this.firstFormGroup.get('provinciaNormaliza').patchValue(this.datosEdicion.provinciaNormaliza);
                    this.firstFormGroup.get('tipoViaNormaliza').patchValue(this.datosEdicion.tipoViaNormaliza);
                }
            });

        // Retomar tramitación
        this.generalService.getEmptyFormNormalizacion()
            .subscribe(data => {
                if (data && this.firstFormGroup.get('nombreViaNormaliza').value === '') {
                    this.firstFormGroup.get('codigoPostalNormaliza').patchValue(data.codigoPostalNormaliza);
                    this.firstFormGroup.get('localidadNormaliza').patchValue(data.localidadNormaliza);
                    this.firstFormGroup.get('nombreViaNormaliza').patchValue(data.nombreViaNormaliza);
                    this.firstFormGroup.get('numeroNormaliza').patchValue(data.numeroNormaliza);
                    this.firstFormGroup.get('provinciaNormaliza').patchValue(data.provinciaNormaliza);
                    this.firstFormGroup.get('tipoViaNormaliza').patchValue(data.tipoViaNormaliza);
                    if (data.codigoPostalNormaliza && data.codigoPostalNormaliza !== '') {
                        this.onChangeZip(data.codigoPostalNormaliza);
                    }
                    this.normalizadorService.setFormularioNormalizacion(this.firstFormGroup);
                }
            });

        this.amenaService.getMigrationData()
            .subscribe((data: any) => {
                this.migrationData = data;
                if (this.migrationData && this.migrationData.migrationFibra) {
                    this.firstFormGroup.disable();
                    if (this.muestraBoton && !this.isLoading) {
                        this.onNormalizarDireccion();
                    }
                }
            });

        this.firstFormGroup.get('provinciaNormaliza').disable();
    }

    // Formateamos los datos para enviarlos al servicio
    getDataNormalizar() {
        let body = {
            streetNr: `${this.firstFormGroup.value.numeroNormaliza}`,
            streetName: getNameStreet(this.firstFormGroup.value.nombreViaNormaliza, this.datosTipoVia, 'code'),
            city: this.firstFormGroup.value.localidadNormaliza,
            stateOrProvince: this.firstFormGroup.value.provinciaNormaliza,
            streetType: this.getTypeStreet(this.firstFormGroup.value.tipoViaNormaliza),
            postCode: `${this.firstFormGroup.value.codigoPostalNormaliza}`
        };

        return body;
    }

    // Añadimos todos los valores del formulario al formGroup del primer paso
    setFormFirstStep() {
        this.firstFormGroup.get('tipoViaNormaliza').patchValue(this.firstFormGroup.value.tipoViaNormaliza);
        this.firstFormGroup.get('nombreViaNormaliza').patchValue(this.firstFormGroup.value.nombreViaNormaliza);
        this.firstFormGroup.get('numeroNormaliza').patchValue(this.firstFormGroup.value.numeroNormaliza);
        this.firstFormGroup.get('codigoPostalNormaliza').patchValue(this.firstFormGroup.value.codigoPostalNormaliza);
        this.firstFormGroup.get('localidadNormaliza').patchValue(this.firstFormGroup.value.localidadNormaliza);
        this.firstFormGroup.get('provinciaNormaliza').patchValue(this.firstFormGroup.value.provinciaNormaliza);
    }

    // Metodos ON

    // Llamada al micro para realizar la consulta de normalización horizontal
    onNormalizarDireccion() {
        this.normalizadorService.setErrorPeticionNormaliza(false);
        this.normalizadorService.setMsgErrorNormaliza('');

        if (!this.firstFormGroup.get('tipoViaNormaliza').value || this.firstFormGroup.get('tipoViaNormaliza').value === '') {
            searchRoadType(this.firstFormGroup.get('nombreViaNormaliza').value, this.datosTipoVia, 'code', this.firstFormGroup.get('tipoViaNormaliza'));
        }

        this.validateAllFormFields(this.firstFormGroup);
        this.firstFormGroup.enable();
        if (this.firstFormGroup.valid) {
            this.onChangeLoading(true);
            this.firstFormGroup.disable();
            const body = this.getDataNormalizar();
            this.normalizadorService.normalizarHorizontal(body)
                .subscribe((data: any) => {
                    if (data.msg) {
                        data = data.msg;
                    }
                    if (Array.isArray(data) && data.length > 0) {
                        this.normalizadorService.setMuestraBotonNormalizacion(false);
                        this.normalizadorService.setMuestraCobertura(true);
                        this.normalizadorService.setDatosNormalizacion(data);
                        this.normalizadorService.setLocalidades(data);
                        this.normalizadorService.setFormularioNormalizacion(this.firstFormGroup);
                        this.firstFormGroup.disable();
                        this.onChangeLoading(false);
                    } else {
                        this.normalizadorService.setErrorPeticionNormaliza(true);
                        this.normalizadorService.setMsgErrorNormaliza(data ? data : 'No existen resultados para los datos indicados.');
                        this.onChangeLoading(false);
                        this.firstFormGroup.enable();
                    }
                }, (error) => {
                    this.normalizadorService.setErrorPeticionNormaliza(true);
                    this.normalizadorService.setMsgErrorNormaliza(error.error.error.msg);
                    this.onChangeLoading(false);
                    this.firstFormGroup.enable();
                });
        } else {
            const elements: any = document.getElementsByClassName('mat-input-element ng-invalid');

            if (elements.length > 0) {
                elements[0].focus();
            }

            return;
        }
    }

    onChangeLoading(state) {
        if (state === true) {
            this.isLoading = true;
            this.textDefault = 'Normalizando ...';
        } else {
            this.isLoading = false;
            this.textDefault = 'Normalizar dirección';
        }
    }

    // VALIDACIONES

    // Comprueba si existen errores de validacion y hace saltar estos errores
    validateAllFormFields(formGroup: FormGroup | FormArray): boolean {
        const keysArray = formGroup instanceof FormGroup ? Object.values(formGroup.controls) : formGroup.controls;
        keysArray.forEach(control => {
            if (control instanceof FormControl) {
                control.markAsTouched({onlySelf: false});
                control.updateValueAndValidity();
            } else if (control instanceof FormGroup || control instanceof FormArray) {
                this.validateAllFormFields(control);
            }
        });
        return formGroup.invalid;
    }

    // Función para manejar los mensajes de error
    public errorHandling = (control: string, error: string) => {
        if (this.firstFormGroup.get(control).invalid && (this.firstFormGroup.get(control).dirty || this.firstFormGroup.get(control).touched)) {
            return this.firstFormGroup.controls[control].hasError(error);
        }
    };

    onAutocompleteSelected($event) {
        const addressComponents: any[] = $event.address_components;

        if (addressComponents != null && addressComponents.length > 0) {
            this.firstFormGroup.get('tipoViaNormaliza').patchValue('');
            this.firstFormGroup.get('nombreViaNormaliza').patchValue('');
            this.firstFormGroup.get('numeroNormaliza').patchValue('');
            this.firstFormGroup.get('codigoPostalNormaliza').patchValue('');
            this.firstFormGroup.get('localidadNormaliza').patchValue('');
            this.firstFormGroup.get('provinciaNormaliza').patchValue('');

            for (const addressComponent of addressComponents) {
                let field = '';
                const types: string[] = addressComponent.types;
                let value: string = addressComponent.long_name;

                if (types.includes('route')) {
                    field = 'nombreViaNormaliza';
                    value = searchRoadType(value, this.datosTipoVia, 'code', this.firstFormGroup.get('tipoViaNormaliza'));
                } else if (types.includes('street_number')) {
                    field = 'numeroNormaliza';
                } else if (types.includes('postal_code')) {
                    field = 'codigoPostalNormaliza';
                    this.onChangeZip(value);
                } else if (types.includes('locality')) {
                    field = 'localidadNormaliza';
                } else if (types.includes('administrative_area_level_2')) {
                    field = 'provinciaNormaliza';
                    value = value.toUpperCase();
                }

                if (field !== '') {
                    this.firstFormGroup.get(field).patchValue(value);
                }
            }
        }
        if (this.firstFormGroup.get('numeroNormaliza').value === '') {
            this.formNumber.nativeElement.focus();
        }
    }

    onChangeZip(value) {
        onChangeZip(value, this.datosProvincia, 'postal_code', this.firstFormGroup.get('provinciaNormaliza'));
    }

    getTypeStreet(value: string): string {
        if (this.datosTipoVia && this.datosTipoVia.length && value) {
            if (value.toLowerCase() === 'passatge') {
                value = 'pasaje';
            }
            const valueNormalized = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

            const tipoVia = this.datosTipoVia.filter(item => {
                const codeNormalized = item.code.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

                return valueNormalized.toLowerCase() === codeNormalized.toLowerCase();
            });

            if (tipoVia && tipoVia.length) {
                const code = tipoVia[0].code;

                return code;
            } else {
                return 'CALLE';
            }
        }

        return 'CALLE';
    }

    onAddressChange(event) {
        setTimeout(() => {
            const text = event.target.value;
            const autocompleteBoxes = document.getElementsByClassName('pac-container pac-logo');
            let autocompleteBox = autocompleteBoxes[autocompleteBoxes.length - 1];

            for (let i = 0; i < autocompleteBoxes.length; i++) {
                if (autocompleteBoxes.item(i).clientWidth > 0 && autocompleteBoxes.item(i).innerHTML) {
                    autocompleteBox = autocompleteBoxes.item(i);
                    break;
                }
            }

            if (text && text !== '') {
                this.manualAddress.nativeElement.style.display = 'flex';
                this.manualAddress.nativeElement.style.top = 'calc(100% + ' + (autocompleteBox.clientHeight - 20) + 'px)';
                this.manualAddressText.nativeElement.innerText = text;
            } else {
                this.onAddressFocusOut();
            }
        }, 300)
    }

    onAddressFocusOut() {
        setTimeout(() => {
            this.manualAddress.nativeElement.style.display = 'none';
            this.manualAddress.nativeElement.style.top = '100%';
            this.manualAddressText.nativeElement.innerText = '';
        }, 100)
    }
}
